import { ArticleFeatureDto } from "./article-feature.dto";
import { ArticleDto } from "./article.dto";

export class ArticleFeatureValueDto {
    id?: number;
    value!: string;
    featureId?: number;
    feature!: ArticleFeatureDto;
    articleId?: number;
    article!: ArticleDto;
    frontId?: string;
    showOnScreen?: boolean;
}
